import { Controller } from 'stimulus'

export default class extends Controller {
  static values = { placement: String }

  connect () {
    this.element.addEventListener('click', this._handleClick.bind(this), false)
  }

  // -----------------------------------------------------------------------------------------------

  // Если publisher.js не загрузился (адблок, сбой CDN), клик не перехватываем:
  // ссылка уводит на страницу настройки источников — фоллбэк из документации Google.
  _handleClick (event) {
    if (!window.preferredSourceReady) { return }

    event.preventDefault()
    this._track()
    window.preferredSourceReady.then(preferredSource => preferredSource.addPreferredSource())
  }

  _track () {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({ event: 'preferred_source_click', placement: this.placementValue })
  }
}
